// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module--header--3RJmv","mainTitle":"styles-module--mainTitle--2XHV5","break":"styles-module--break--E6OMx"};